// extracted by mini-css-extract-plugin
module.exports = {"devButton":"depositsLinks_devButton__2piHO"};